import Color from 'color';
import store from '@/store';

const colorFuncs = {
  lightenBy: (color, ratio) => {
    const lightness = color.lightness();

    return color.lightness(lightness + (100 - lightness) * ratio);
  },
  darkenBy: (color, ratio) => {
    const lightness = color.lightness();

    return color.lightness(lightness - lightness * ratio);
  }
};

export default {
  inserted() {
    let styles = store._modules.root.state.domainConfig.styles,
      style = document.createElement('style'),
      brandColor = new Color(styles.brand_color || '#2196F3'),
      backgroundColor = new Color(styles.bg_color || '#FFF'),
      textColor = new Color(styles.text_color || '#333'),
      headerTextColor = new Color(styles.links.text_color || '#333'),
      headerBackgroundColor = new Color(styles.header.bg_color || '#FFF'),
      inputLabelColor = new Color(styles.inputs.label_color || '#333'),
      inputBackgroundColor = new Color(styles.inputs.bg_color || '#FFF'),
      inputTextColor = new Color(styles.inputs.text_color || '#333'),

      textColorWhenBackgroundIsBrand = brandColor.isLight() ? 'rgba(0,0,0,.87)' : '#fff',

      brandColor20 = colorFuncs[`${brandColor.isLight() ? 'darken' : 'lighten'}By`](brandColor, .2),
      brandColor65 = colorFuncs[`${brandColor.isLight() ? 'darken' : 'lighten'}By`](brandColor, .65),

      headerTextColor15 = colorFuncs[`${headerTextColor.isLight() ? 'darken' : 'lighten'}By`](headerTextColor, .15),
      headerTextColor20 = colorFuncs[`${headerTextColor.isLight() ? 'darken' : 'lighten'}By`](headerTextColor, .2),

      headerBackgroundColor25 = colorFuncs[`${headerBackgroundColor.isLight() ? 'darken' : 'lighten'}By`](headerBackgroundColor, .25),

      backgroundColor5 = colorFuncs[`${backgroundColor.isLight() ? 'darken' : 'lighten'}By`](backgroundColor, .05),
      backgroundColor25 = colorFuncs[`${backgroundColor.isLight() ? 'darken' : 'lighten'}By`](backgroundColor, .3),

      labelColor40 = inputLabelColor.fade('.4'),

      inputTextColor40 = inputTextColor.fade('.4'),
      inputBackgroundColor5 = colorFuncs[`${inputBackgroundColor.isLight() ? 'darken' : 'lighten'}By`](inputBackgroundColor, .05);


    style.innerHTML = `

      .text-brand,
      .checkout-step.router-link-exact-active,
      #content a.text-brand-secondary-850,
      .checkout-step.router-link-active,
      .vs-tooltip__icon,
      #content select + svg,
      #content .pd__ps-cont svg,
      .text-orange,
      .vs-layout .accordion-heading__icon {
        color: ${styles.brand_color || '#2196F3'};
      }

      .bg-brand,
      #content .form-input--radio > .form-input__mark:after,
      #content .form-input > input:checked ~ .form-input__mark {
        background: ${styles.brand_color || '#2196F3'};
      }

      #content .form-input--radio > input:checked ~ .form-input__mark {
        background: transparent;
      }

      .border-brand,
      #content .form-input > input:checked ~ .form-input__mark {
        border-color: ${styles.brand_color || '#2196F3'};
      }

      .hover_bg-brand-900:hover,
      .focus_bg-brand-900:focus {
        background-color: ${brandColor20};
      }

      #content .form-input > .form-input__mark:after {
        border-color: ${textColorWhenBackgroundIsBrand};
      }

      .wrapper,
      .bg-gray-form-bg,
      #contact_form,
      #content .modal__content,
      .upsell .bg-white,
      .form-input__mark,
      .actions-select__dropdown.bg-white,
      #content .order-summary-container.bg-white > .border.border-border,
      .vs-layout.accordion-heading,
      .accordion-content.accordion-content--white {
        background: ${styles.bg_color || '#fff'};
      }

      #content .bg-brand-secondary-50,
      #content .collection__banner {
        background-color: ${backgroundColor25};
      }

      #content .border-border.product-details-color,
      #content .product-details-color .border-border,
      .accordion-content,
      .accordion {
        border-color: ${backgroundColor25};
      }

      #content .border-white.product-details-color {
        border-color: ${styles.bg_color || '#fff'};
      }

      .wrapper.text-brand-secondary,
      .wrapper .text-brand-secondary,
      .wrapper .text-brand-secondary-100,
      .wrapper .text-brand-secondary-900,
      .wrapper .text-brand-secondary-850,
      .wrapper .text-brand-secondary-300,
      .checkout-step,
      div.product-description__html b,
      .modal__close,
      .modal__close:hover,
      #content .breadcrumbs .text-brand-secondary {
        color: ${styles.text_color || '#333'};
      }

      .modal__close:hover {
        opacity: .8;
      }

      header,
      header .text-brand,
      header .text-white,
      .wrapper header .text-brand-secondary,
      header .border-brand-secondary-200.text-brand-secondary,
      header .border-white::placeholder,
      header .border-brand-secondary-200::placeholder,
      footer .text-brand-secondary-400,
      .csid,
      .toast {
        color: ${styles.links.text_color || '#333'};
      }

      header .border-b,
      .toast {
        border-color: ${styles.header.border_color || '#ccc'};
      }

      header .border-brand,
      header .border-white,
      header .border-brand-secondary-200 {
        border-color: ${styles.links.text_color || '#333'};
      }

      header .menu-content .bg-white,
      header .bg-brand {
        background-color: ${styles.links.text_color || '#333'};
      }

      header .border-white:focus,
      header .border-brand-secondary-200:focus {
        border-color: ${headerTextColor20};
      }

      header,
      header .bg-white,
      header .menu-content,
      footer.bg-brand-secondary,
      .toast {
        background: ${styles.header.bg_color || '#fff'};
      }

      header .buyer-text-input {
        background: transparent;
      }

      #content .border-border,
      #content .border-brand-secondary-75,
      #content .md_border-brand-secondary-75,
      #content .border-brand-secondary-200,
      #content .md_border-brand-secondary-200 {
        border-color: ${backgroundColor25};
      }

      #content button,
      .pagination .bg-brand,
      svg .fill-current.text-white {
        color: ${textColorWhenBackgroundIsBrand};
      }

      #content button.text-brand {
        color: ${styles.brand_color || '#2196F3'};
      }

      #content button.bg-white {
        background-color: transparent;
      }

      #content button.bg-white:hover {
        background-color: ${backgroundColor5};
      }

      #content input[type=text],
      #content input[type=tel],
      #content input[type=email],
      #content select.text-brand-secondary,
      #content textarea.border,
      #content .pd__ps-cont,
      #content .quantity-select {
        border-radius: ${styles.inputs.border_radius || 0};
        background-color: ${styles.inputs.bg_color || 'transparent'};
        color: ${styles.inputs.text_color || '#333'};
        border-color: ${styles.inputs.border_color || '#333'};
      }

      #content .buyer-select select {
        border-color: ${styles.inputs.border_color || '#333'};
      }

      #content select.text-brand-secondary-100 {
        color: ${inputTextColor40 || '#333'};
      }

      #content input[type=text]:focus,
      #content input[type=tel]:focus,
      #content input[type=email]:focus,
      #content select:focus,
      #content textarea:focus,
      #content .pd__ps-cont:focus,
      #content .quantity-select:focus {
        background-color: ${inputBackgroundColor5};
      }

      #content .quantity-select .text-gray-200 {
        color: ${brandColor65};
      }

      #content input[type=text]::placeholder,
      #content input[type=tel]::placeholder,
      #content input[type=email]::placeholder {
        color: ${inputTextColor40 || '#333'};
      }

      .wrapper label.text-brand-secondary {
        color: ${styles.inputs.label_color || '#333'};
      }

      #content select.border,
      #content select.border:focus {
        background-color: transparent;
      }

      #content select.border ~ .bg-white,
      .actions-select__dropdown.bg-white > .border {
        background-color: ${styles.inputs.bg_color || 'transparent'};
      }

      #content select.border:focus ~ .bg-white {
        background-color: ${inputBackgroundColor5};
      }

      #content label .text-brand-secondary-100 {
        color: ${labelColor40};
      }

      #content .alert__message {
        color: ${styles.brand_color || '#2196F3'};
        border-color: ${styles.brand_color || '#2196F3'};
        background-color: ${brandColor65};
      }

      #content .order-summary-container.bg-white {
        background-color: ${backgroundColor5};
        border-color: ${backgroundColor25};
      }

      @media (min-width: 768px) {
        #content .product-details-widgets.md_bg-brand-secondary {
          background-color: ${backgroundColor25};
        }
      }

      #content .icon-shirt .text-brand {
        color: ${styles.brand_color || '#2196F3'};
      }

      #content .icon-shirt .text-brand-900,
      .wrapper .text-brand-secondary-300.hover_text-error:hover,
      .wrapper .text-error,
      .hover_text-brand-900:hover,
      .hover_text-brand-900:focus {
        color: ${brandColor20};
      }

      #content .icon-shirt .text-brand-secondary-800 {
        color: #666;
      }

      #content .icon-shirt .text-brand-secondary-900 {
        color: #aaa;
      }

      #content .breadcrumbs {
        color: ${backgroundColor25};
      }

      #content .breadcrumbs .text-brand-secondary {
        text-decoration: underline;
      }

      #content .vertical-gradient--right {
        right: 0;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), ${styles.bg_color});
      }

      #content .vertical-gradient--left {
        left: 0;
        background: linear-gradient(to right, ${styles.bg_color}, rgba(255, 255, 255, 0));
      }

      @-webkit-keyframes autofill {
        to {
          background-color: ${styles.inputs.bg_color || 'transparent'};
          color: ${styles.inputs.text_color || '#333'};
        }
      }

      @-webkit-keyframes autofill-select {
        to {
          background-color: transparent;
          color: ${styles.inputs.text_color || '#333'};
        }
      }

      @-webkit-keyframes autofill-focus {
        to {
          background-color: ${inputBackgroundColor5};
          color: ${styles.inputs.text_color || '#333'};
        }
      }

      #content input:-webkit-autofill,
      #content input:-webkit-autofill:hover {
        -webkit-animation-name: autofill;
        -webkit-animation-fill-mode: both;
      }

      #content input:-webkit-autofill:focus {
        -webkit-animation-name: autofill-focus;
        -webkit-animation-fill-mode: both;
      }

      #content select:-webkit-autofill,
      #content select:-webkit-autofill:hover,
      #content select:-webkit-autofill:focus {
        -webkit-animation-name: autofill-select;
        -webkit-animation-fill-mode: both;
      }

      #content select:-webkit-autofill:focus ~ .bg-white {
        background-color: ${inputBackgroundColor5};
      }

      .product-group-product .text-brand-secondary,
      .vs-table__cell {
        color: rgba(0,0,0,.8);
      }

      .product-group-product:hover,
      .product-group-product:active {
        box-shadow: 0 0 18px ${backgroundColor.isLight() ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, .75)'};
      }

      @media (min-width: 768px) {
        .actions {
          box-shadow: 0 0 6px ${backgroundColor.isLight() ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, .75)'};
        }
      }

      @media (min-width: 1024px) {
        .actions {
          box-shadow: 0 0 18px ${backgroundColor.isLight() ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, .75)'};
        }
      }

      .bg-contact-widget {
        background-color: ${backgroundColor.isLight() ? 'rgba(0, 0, 0, .05)' : 'rgba(255, 255, 255, .1)'};
      }

      .product-group-product .text-brand {
        color: ${brandColor.luminosity === 1 ? '#ccc' : brandColor}
      }
    `;

    document.head.appendChild(style);
  },
};